export enum CheckState {
    NotPaid = 0,
    PartiallyPaid = 1,
    Paid = 2,
}